import { render, staticRenderFns } from "./AttestatsiyaKomissiyasi.vue?vue&type=template&id=4ba069f3&"
import script from "./AttestatsiyaKomissiyasi.vue?vue&type=script&lang=js&"
export * from "./AttestatsiyaKomissiyasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports